import { useContext } from 'react'

import { Screen } from '../../../../../context'
import { useKeyboard } from '../../../../../hooks'
import {
  PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH,
  useMultipleViewTypeList,
} from '../../../../MultipleViewTypeList'
import { getApplicantProfileLink } from '../../../../RentalPortalApplicant'
import { APPLICANT_PREVIEW_REGIME_AVAILABLE } from '../../RentalPortalApplicants.constants'

import { isSplitPaneEscapeClaimed } from './useRentalPortalApplicantsMultipleViewTypeList.utils'

export function useRentalPortalApplicantsMultipleViewTypeList({
  handleReload,
  handleSetPreview,
  handleSetView,
  handleUpdateConfig,
  items,
  listViewType,
  preview,
}) {
  const { width } = useContext(Screen)

  const multipleViewTypeList = useMultipleViewTypeList({
    getProfileLink: getApplicantProfileLink,
    handleReload,
    handleSetPreview,
    handleSetView,
    handleUpdateConfig,
    items,
    listViewType,
    preview,
  })

  function handleEscape() {
    if (!isSplitPaneEscapeClaimed()) {
      multipleViewTypeList.handleResetViewTypeToPlainBody()
    }
  }

  useKeyboard(null, handleEscape)

  return {
    ...multipleViewTypeList,
    isSplitAvailable:
      APPLICANT_PREVIEW_REGIME_AVAILABLE &&
      width > PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH,
  }
}
